<template>

    <bottom-sheet ref="bottomsheet" :selfClose="true">

        <div class="bsms">

            <div class="bsms__container">

                <img src="/img/navigation/mailbox-empty.svg" class="img__40 mt__8">

                <p class="text-lSemibold mt__8">{{ $t('mailbox_to_clean') }}</p>

            </div>

            <div class="divider"></div>

            <div class="bsms__container">

                <button class="text-lSemibold color__aquamarine bsms__select-all mt__16"
                        v-show="mailboxes.length > 1"
                        @click="selectAll">
                    {{ $t('cleaning_select_all_inbox') }}
                </button>

                <div class="bsms__mailboxes">

                    <div class="bsms__mailbox" v-for="mailbox in mailboxes"
                         @click="toggleEmail(mailbox.email)">
                        <div class="bsms__mailbox__left">
                            <img :src="getProviderImg(mailbox.provider)" class="img__40" :class="{'shutdown-provider': mailbox.providerShutdown}">
                        </div>
                        <div class="bsms__mailbox__middle">
                            <p class="text-baseSemibold-2" :class="{'shutdown': mailbox.providerShutdown}">{{ mailbox.email }}</p>
                            <p class="text-sSemibold" :class="{'color__stone': selectedMailboxes.indexOf(mailbox.email) === -1, 'color__aquamarine': selectedMailboxes.indexOf(mailbox.email) > -1, 'color__silver': mailbox.providerShutdown}">
                                {{ $tc('cleaning_nb_mails_to_sort', mailbox.count, {nb_emails: mailbox.count}) }}</p>
                        </div>
                        <div class="bsms__mailbox__right">
                            <img src="/img/icons/alert-red.svg" class="img__24" v-if="mailbox.providerShutdown">
                            <lottie-loader :size="24" v-else-if="!mailbox.done"></lottie-loader>
                            <img v-else
                                 :src="`/img/newsletters-v2/checkbox-2-${selectedMailboxes.indexOf(mailbox.email) > -1 ? 'on' : 'off'}.svg`"
                                 class="img__24">
                        </div>
                    </div>

                </div>

                <button class="ds__button__medium ds__button__fluid ds__button__secondary text-lSemibold mt__16"
                        @click="validate">{{ $t('cleaning_validate_email_selec') }}
                </button>
                <p class="ds__link__default ds__link__fluid text-lSemibold mt__16" @click="goAddInbox">
                    {{ $t('cleaning_done_add_mailbox_cta') }}</p>

            </div>

        </div>

    </bottom-sheet>

</template>

<script>
import Vuex from 'vuex'

import Tag from '@/modules/tag'

import BottomSheet from '@/components/bottomSheet/BottomSheet'
import LottieLoader from '@/components/lottie/LottieLoader'

export default {

    name: 'bottom-sheet-mailboxes-selection',

    components: {
        LottieLoader,
        BottomSheet
    },

    watch: {
        $mq: function (newValue) {
            if (newValue === 'lg') {
                this.close()
            }
        }
    },

    computed: {
        ...Vuex.mapGetters([
            'mailboxes',
            'selectedMailboxes'
        ])
    },

    methods: {

        ...Vuex.mapActions([
            'updateSelectedMailboxes'
        ]),

        open() {
            this.$refs.bottomsheet.open()
        },

        close() {
            this.$refs.bottomsheet.close()
        },

        getProviderImg(provider) {
            switch (provider) {
                case 'google':
                    return '/img/providers/circle-google.png'
                case 'icloud':
                    return '/img/providers/circle-icloud.png'
                case 'microsoft':
                    return '/img/providers/circle-microsoft.png'
                case 'orange':
                    return '/img/providers/circle-orange.png'
                case 'yahoo':
                    return '/img/providers/circle-yahoo.png'
                default:
                    return '/img/providers/circle-imap.png'
            }
        },

        toggleEmail(email) {
            Tag.clickGA(this, 'select_mailbox')
            const index = this.selectedMailboxes.indexOf(email)
            let newSelectedMailboxes
            if(index > -1) {
                newSelectedMailboxes = this.selectedMailboxes.filter(item => item !== email)
            } else {
                newSelectedMailboxes = [...this.selectedMailboxes, email]
            }
            this.updateSelectedMailboxes(newSelectedMailboxes)
        },

        selectAll() {
            Tag.clickGA(this, 'select_all')
            this.updateSelectedMailboxes(this.mailboxes.map(mailbox => mailbox.email))
        },

        validate() {
            Tag.clickGA(this, 'validate')
            this.close()
        },

        goAddInbox() {
            Tag.clickGA(this, 'add_mailbox')
            this.$router.push({path: '/add-inbox'})
        }
    }

}

</script>

<style lang="scss" scoped>

.bsms {
    display: flex;
    flex-direction: column;
    width: 100%;

    &__container {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        padding: 0 16px 16px;
    }

    &__select-all {
        text-decoration: underline;
        background-color: $white;
    }

    &__mailboxes {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        margin: 16px 0;
    }

    &__mailbox {
        margin-top: 12px;
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;

        &__left {
            display: flex;
            align-items: center;
            justify-content: center;
        }

        &__middle {
            padding: 0 16px;
            display: flex;
            flex-direction: column;
            align-items: baseline;
            flex: 1;

            > p {
                width: 100%;
                text-align: start;

                &:lang(ar-sa) {
                    text-align: right;
                }
            }
        }

        &__right {
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }
}

.divider {
    height: 1px;
    width: 100%;
    background-color: $silver;
}

.shutdown-provider {
    filter: grayscale(100%);
}

.shutdown {
    color: $stone;
}

</style>
